module.exports = __webpack_public_path__ + "img/node-normal.ef1d7b0a.png";